import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Store } from 'components/common/types/Store.types';
import { getLookupData } from 'modules/api/lookups';
import { cancelFunctions } from 'utils/cancelFunctions';
import { changeChannels } from 'store/userOptions/reducer';
import { getMarketId } from 'store/publisher/selectors';

const useChannels = (): void => {
  const dispatch = useDispatch();
  const channels = useSelector((state: Store) => state.userOptions.channels);
  const marketId = useSelector(getMarketId);

  useEffect(() => {
    if (channels.length >= 1) return;

    const getEnvironments = async (): Promise<void> => {
      try {
        const result = await getLookupData({
          cancelFunctions,
          lookupURLName: 'environment',
          query: '',
        });

        dispatch(changeChannels(result));
      } catch {} // eslint-disable-line no-empty
    };

    getEnvironments();
  }, [marketId]);
};

export default useChannels;
